import isEmpty from "lodash/isEmpty.js"
const BASE_URL_V2 = process.env.BASE_URL_V2

export const state = () => ({
  aiBlocks: null,
  draftSettings: null,
})

export const mutations = {
  SAVE_AI_BLOCKS(state, payload) {
    state.aiBlocks = payload;
    localStorage.setItem('text_draft_ai_blocks', JSON.stringify(payload));
  },
  SAVE_DRAFT_SETTINGS(state, payload) {
    state.draftSettings = payload
  },
}

export const actions = {
  async makeTextDraft({ commit }, payload) {
    return await this.$axios.$post(`${BASE_URL_V2}/admin/draft_edit/`, payload)
  },
  async getDraft({ commit }, { model, model_id }) {
    return await this.$axios.$get(`${BASE_URL_V2}/admin/draft_edit/${model}/${model_id}/`)
  },
  async existDraft({ commit }, { model, model_id }) {
    return await this.$axios.$get(`${BASE_URL_V2}/admin/draft_edit/${model}/${model_id}/exists/`)
  },
  async llmDraft({ commit }, id) {
    return await this.$axios.$post(`${BASE_URL_V2}/admin/draft_edit/${id}/llm/`)
  },
  async createDraftBlock({ commit }, payload) {
    return await this.$axios.$post(`${BASE_URL_V2}/admin/draft_edit/create_block/`, payload)
  },
  async getDraftSettings({ state, commit }) {
    if (isEmpty(state.draftSettings)) {
      const response = await this.$axios.$get(`${BASE_URL_V2}/admin/draft_edit/constants/`)

      if(response){
        commit('SAVE_DRAFT_SETTINGS', response )
        return response
      }

      return null
    }

    return state.draftSettings
  },
}

export const getters = {
  getAiBlocks: () => {
    return JSON.parse(localStorage.getItem('text_draft_ai_blocks'));
  },
  getDraftSettings: (state) => {
    return state.draftSettings
  },
}

